import ChipListComponent from '../ChipListComponent';
import * as React from 'react';
import { FormEvent, useEffect, useState } from 'react';
import TextFieldComponent from '../TextFieldComponent';
import { Grid2 } from '@mui/material';
import ButtonComponent from '../ButtonComponent';
import { Check, PhoneAndroid } from '@mui/icons-material';

interface TelegramSelectComponentProps {
  onChange?: (value: string[]) => void;
  value?: string[];
  gridSize?: number;
  telegramChipGridSize?: number;
}

const TelegramSelectComponent = ({
  onChange,
  telegramChipGridSize = 12,
  gridSize = 6,
  value,
}: TelegramSelectComponentProps) => {
  const [selectedTelegrams, setSelectedTelegrams] = useState<string[]>([]);
  const [telegram, setTelegram] = useState<string>('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setSelectedTelegrams((oldState) => [...oldState, telegram]);
    setTelegram('');
    if (onChange) onChange([...selectedTelegrams, telegram]);
  };

  useEffect(() => {
    if (value) setSelectedTelegrams(value);
  }, [value]);
  return (
    <>
      <Grid2 size={gridSize}>
        <form style={{ display: 'flex' }} onSubmit={handleSubmit}>
          <TextFieldComponent
            value={telegram}
            onChangeText={setTelegram}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderBottomRightRadius: 0,
                  borderTopRightRadius: 0,
                },
              },
            }}
            label={'IDs Telegram para notificações'}
          />
          <ButtonComponent
            type="submit"
            disabled={!telegram.trim()}
            sx={{
              mb: 3,
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              height: '70%',
            }}
          >
            <Check />
          </ButtonComponent>
        </form>
      </Grid2>
      {selectedTelegrams && selectedTelegrams.length > 0 && (
        <Grid2 size={telegramChipGridSize} sx={{ mb: 1 }}>
          <ChipListComponent
            chipIcon={<PhoneAndroid />}
            chipData={selectedTelegrams}
            maxChipWidth={250}
            onDelete={(index) => {
              const newVal = selectedTelegrams.filter((_, i) => i !== index);
              if (onChange) onChange(newVal);
              setSelectedTelegrams(newVal);
            }}
          />
        </Grid2>
      )}
    </>
  );
};

export default TelegramSelectComponent;
